import { pdfExports } from '../../../../../constants/exportsPdf';
import { getMunicipalityExportItems } from '../../../../../utilities/getMunicipalityExports';

export const getPdfExportItems = (
  municipality,
  translator,
  downloadReport,
  canDownloadReport,
  canDownloadFullReport,
  buttonStyles,
) => {
  const exports = pdfExports(
    translator,
    downloadReport,
    canDownloadReport,
    canDownloadFullReport,
    buttonStyles,
  );

  return getMunicipalityExportItems(exports, municipality);
};
